import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon-comments"
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <circle cx="12" cy="12" r="12" fill="#E07575" />
        <g filter="url(#filter0_d)" fill="#fff">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 7a2 2 0 00-2 2v3a2 2 0 002 2h1v2l1.5-2H17a2 2 0 002-2V9a2 2 0 00-2-2H7z"
          />
          <path d="M8 14h.5v-.5H8v.5zm0 2h-.5v1.5l.9-1.2L8 16zm1.5-2v-.5h-.25l-.15.2.4.3zm-4-5A1.5 1.5 0 017 7.5v-1A2.5 2.5 0 004.5 9h1zm0 3V9h-1v3h1zM7 13.5A1.5 1.5 0 015.5 12h-1A2.5 2.5 0 007 14.5v-1zm1 0H7v1h1v-1zm-.5.5v2h1v-2h-1zm.9 2.3l1.5-2-.8-.6-1.5 2 .8.6zm8.6-2.8H9.5v1H17v-1zm1.5-1.5a1.5 1.5 0 01-1.5 1.5v1a2.5 2.5 0 002.5-2.5h-1zm0-3v3h1V9h-1zM17 7.5A1.5 1.5 0 0118.5 9h1A2.5 2.5 0 0017 6.5v1zm-10 0h10v-1H7v1z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="none" d="M0 0h24v24H0z" />
        </clipPath>
        <filter
          id="filter0_d"
          x=".5"
          y="6.5"
          width="23"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
